<template>
    <div class="reconsider-basic">
        <div v-if="cdData.isShow === 1 && cdData.cdjg == '待复议'">
            <Slogan theTitle="复议裁定信息"/>
            <van-cell-group>
                <div v-if="cdData.show === 1">
                    <van-field
                            v-if="cdData.cdjg == '待复议'"
                            v-model="cdData.cdjg"
                            clearable
                            readonly
                            label="复议结果"
                    ></van-field>
                </div>
            </van-cell-group>
        </div>
        <div v-if="isShow == 1">
            <Slogan theTitle="复议审核信息"/>
            <van-cell-group>
                <span class="fd-invalid-tips" v-if="data.cFyzt === '2'">您提交的复议申请正在审核中，请耐心等待。</span>
                <div v-else>
                    <van-field
                            v-model="shData.cShjg"
                            clearable
                            readonly
                            label="审核结果"
                    ></van-field>
                    <van-field
                            v-show="this.shData.shzt != 1"
                            v-model="shData.cShyj"
                            clearable
                            readonly
                            label="退回原因"
                    ></van-field>
                    <van-field
                            v-model="shData.dtShsj"
                            readonly
                            clickable
                            label="审核日期"
                    ></van-field>
                </div>
            </van-cell-group>
        </div>
<!--        复议基本信息 -->
        <cc-preview-module title="复议基本信息" :data="basicTransformData"></cc-preview-module>
    </div>
</template>

<script>
    import Slogan from '../../../components/common/slogan'
    // 预览模块
    import ccPreviewModule from '@/components/common/preview-module/index.vue';
    import {columnsFYSX,columnsFYAJLX,columnsSQR} from '../../../utils/option.js'
    import {
      typeTime2,
      typeFysh,
      typeFyzt,
      fyjgType
    }
    from '../../../filters/index';
    // 数据转换
    import transformData from '@/views/mixins/transform-data.js';
    export default {
        mixins: [transformData],
        props: {
            // 数据
            data: {
                type: Object
            },
            // 依赖的数据 审核信息的数据
            dependData: {
                type: Object
            }
        },
        data() {
            return {
                fyid:'',
                shData:{
                    shzt:"",//审核状态
                    cShjg:"",//审核结果
                    cShyj:"",//审核不通过原因
                    dtShsj:"",//审核时间
                },
                cdData:{
                    cdjg:"",//裁定结果
                    cdjg2:"",
                    cdsj:"",//审核时间
                    show: '', // 1 显示待裁定 2 显示已复议裁定信息
                    isShow: '',// 1 显示复议裁定信息页签 2 不显示复议裁定信息页签
                },
                formData: {
                    nSqfy:'',
                    cSqfymc: '',//申请第一法院名称
                    cBqah: '',//保全案号
                    nFysx:'',//复议事项
                    nFysxText:'',//复议事项文字
                    nAjlx: '',//案件类型
                    nAjlxText: '',
                    cTjrlx: '',//提交人身份
                    cTjrlxText: '',
                    dtSqrq:'',//申请日期
                    cFyky:'',//复议理由
                },
                shz:'',
                showCalendar:false,//是否展示日期
                showPicker:false,
                columnsFYSX:columnsFYSX,
                showPickerAjlx:false,
                columnsFYAJLX:columnsFYAJLX,
                showPickeSQR:false,
                columnsSQR:columnsSQR,
                isShow: 0,
                // 基础数据转换后数据
                basicTransformData: []
            }
        },
        components: {
            Slogan,
            ccPreviewModule
        },
        mounted() {

        },
        methods: {
            getBasic(){
                // 基础转换之后的数据
                this.basicTransformData = [this.getBasicTransformData(this.data)];
                if ("1" != this.data.cFyzt) {
                    this.isShow = 1;
                }
                if (this.data.cFyzt == "2") {
                    this.shz = "您提交的复议申请正在审核中，请耐心等待。";
                    return;
                }
                this.shData.shzt = this.data.cShjg;
                this.shData.cShjg = typeFysh(this.data.cShjg);
                this.shData.cShyj = this.data.cShyj;
                this.shData.dtShsj = typeTime2(this.data.dtShsj);
                this.cdData.cdjg = typeFyzt(this.data.cFyzt);
            },
            //获取裁定结果
            getFYSHXX() {
                // 裁定结果
                this.cdData.cdjg2 = fyjgType(this.dependData.cdjg);
                this.cdData.cdsj = this.dependData.cdsj;
                if (this.dependData.fyzt == '5' || this.dependData.fyzt == '3') {
                    this.cdData.isShow = 1;
                } else {
                    this.cdData.isShow = 2;
                    return;
                }
                if (this.dependData.cdjg == "") {
                    this.cdData.show = 1;
                } else {
                    this.cdData.show = 2;
                }
            },
            //下载裁定书
            downloadCDS(){

            },

            /**
             * 获取基础信息的转换数据
             * */
            getBasicTransformData(data) {
                const _transformItemData = [];
                _transformItemData.push(this.getRowData('申请法院', data.cSqfymc));
                _transformItemData.push(this.getRowData('案号', data.cBqah));
                _transformItemData.push(this.getRowData('复议事项', data.nFysxText));
                _transformItemData.push(this.getRowData('案件类型', data.nAjlxText));
                _transformItemData.push(this.getRowData('提交人身份', data.cTjrlxText));
                _transformItemData.push(this.getRowData('创建申请日期', data.dtSqrq));
                // 复议理由需要单独占一行
                _transformItemData.push(this.getRowData('复议理由', data.cFyky, true, true));
                return _transformItemData;
            }
        },
        created() {
            //获取复议基本信息
            this.getBasic();
            this.getFYSHXX();
        },
    }
</script>
